import * as React from 'react';
import { Radio } from 'antd';

const RadioGroup = Radio.Group;

interface BrandEditorCheckListProps {
	brands: BrandSummary[];
	value: number | null;
	mode: ControlMode;
	onChanged: (number: number | null) => void;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class BrandEditorCheckListView extends React.Component<BrandEditorCheckListProps, {}> {
	public render() {
		const { brands, mode, onChanged, value } = this.props;

		const radios = [];
		radios.push(<Radio className="list-radio-filter" value={-1} disabled={mode == "display"}>All</Radio>);
		for (const brand of brands) {
			radios.push(
				<Radio className="list-radio-filter" disabled={mode == "display"} value={brand.id}>
					{brand.name}
				</Radio>
			);
		}
		return (
			<RadioGroup
				disabled={mode == "display"}
				onChange={(e) => {
					if (e.target.value == -1) {
						onChanged(null);
					} else {
						onChanged(e.target.value);
					}
				}}
				value={value != null ? value : -1}
			>
				{radios}
			</RadioGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/brands/parts/brand-editor-checkList.view.tsx